<template>
  <div ref="mainContainer">
    <div :class="isMobile ? 'floating-form' : ''" ref="mainContainer">
      <v-card outlined tile style="border-left: none; border-right: none; border-top: none;">

        <v-card-title style="font-size: 1.25rem;" class="justify-center">
          <v-btn class="d-flex justify-start no-background-hover" :ripple="false" @click="toMain()" icon absolute left>
            <img src="../../assets/btn_pre_n.png" class="btn_pre_img">
          </v-btn><span class="text-center" style="font-weight:600">검사코드</span></v-card-title>
      </v-card>

    </div>

    <template>

      <!-- <v-form onSubmit="return false;"> -->
      <v-container fluid class="pb-0">
        <v-row>
          <v-col class="d-flex align-center caption pr-0 pl-2 pb-0" cols="2">
            <span style="font-size: 13px; color: black;" class="text--secondary"
              :class="width < 300 ? 'vw-text' : ''">검사파트</span>
          </v-col>
          <v-col class=" pb-0" cols="10" @click="open()">
            <v-text-field single-line color="success" dense @click="open()" readonly v-model="partName"
              @click:append="open()" class="text-field rounded-lg input_arrow" outlined label="전체"
              append-icon="mdi-triangle-small-down" hide-details :class="width < 300 ? 'vw-text' : ''">
              <template v-slot:append>
                <img src="../../assets/btn_input_arrow.png" class="input_arrow_img">
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex align-center pr-0 pl-2 pt-0 caption pb-0" cols="2">
            <span style="font-size: 13px; color: black;" class="text--secondary"
              :class="width < 300 ? 'vw-text' : ''">검색어</span>
          </v-col>
          <v-col cols="10" class="pt-1 pb-1" :elevation="0">
            <v-text-field color="success" single-line outlined dense v-model="searchWord" class="text-field rounded-lg"
              label="검사명칭, 검사코드, 청구코드" hide-details :class="width < 300 ? 'vw-text' : ''">
              <template v-slot:prepend-inner>
                <img src="../../assets/icon_search.png" class="icon_search_img">
              </template>
              <template v-slot:append v-if="searchWord !== ''">
                <v-icon color="success" @click="searchWord = ''">
                  mdi-close-circle
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex align-center pr-0 pl-2 pt-0 caption pb-4" cols="2">
            <span style="font-size: 13px; color: black;" class="text--secondary"
              :class="width < 300 ? 'vw-text' : ''">검사명칭</span>
          </v-col>
          <v-col cols="10" class="pt-1 pb-4">
            <!-- <v-chip-group :lable="true" color="success" v-model="testNameIsKorean">
              <v-chip outlined :value="true" @click="setTestNameIsKorean(true)">
                한글명칭
              </v-chip>
              <v-chip outlined :value="false" @click="setTestNameIsKorean(false)">
                영문명칭
              </v-chip>
            </v-chip-group> -->
            <v-btn-toggle dark dense multiple class="no-background-hover" :borderless="true" background-color="#ffffff">
              <v-btn @click="testNameIsKorean = true" icon elevation="0" :ripple="false" class="mr-2">
                <img v-show="testNameIsKorean === true" src="../../assets/btn_testName_ko_s.png"
                  class="btn_status_img_by_test_code">
                <img v-show="testNameIsKorean === false" src="../../assets/btn_testName_ko_n.png"
                  class="btn_status_img_by_test_code">
              </v-btn>
              <v-btn @click="testNameIsKorean = false" icon elevation="0" :ripple="false" class="mr-2">
                <img v-show="testNameIsKorean === false" src="../../assets/btn_testName_en_s.png"
                  class="btn_status_img_by_test_code">
                <img v-show="testNameIsKorean === true" src="../../assets/btn_testName_en_n.png"
                  class="btn_status_img_by_test_code">
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-container>
      <!-- </v-form> -->

      <v-card elevation="0" class="mx-auto pt-3">
        <div v-show="isLoading === true" class="text-center">
          <v-progress-circular style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
            :size="50" color="success" :indeterminate="true">
          </v-progress-circular>
        </div>

        <v-list-item id="list-header" class="rounded-0 pr-0 px-2"
          style="background-color: #959595; height: 48px !important;">
          <v-list-item-action>
            <div class="header-content" @click="toggleSort('testCode')">
              <span style="color: white; font-size: 13px" :class="width < 300 ? 'table-header-text' : ''">검사코드</span>
              <span class="icon-container">
                <v-icon size="20" :color="sortColumn === 'testCode' && sortDirection === 'asc' ? 'white' : '#E0E0E0'"
                  class="text-right up-icon">
                  mdi-triangle-small-up
                </v-icon>
                <v-icon size="20" :color="sortColumn === 'testCode' && sortDirection === 'desc' ? 'white' : '#E0E0E0'"
                  class="text-right down-icon">
                  mdi-triangle-small-down
                </v-icon>
              </span>
            </div>
          </v-list-item-action>
          <v-list-item-action>
            <div class="header-content d-flex justify-start" @click="toggleSort('insuranceCode')">
              <span style="color: white; font-size: 13px" :class="width < 300 ? 'table-header-text' : ''">청구코드</span>
              <span class="icon-container">
                <v-icon size="20"
                  :color="sortColumn === 'insuranceCode' && sortDirection === 'asc' ? 'white' : '#E0E0E0'"
                  class="text-right up-icon">
                  mdi-triangle-small-up
                </v-icon>
                <v-icon size="20"
                  :color="sortColumn === 'insuranceCode' && sortDirection === 'desc' ? 'white' : '#E0E0E0'"
                  class="text-right down-icon">
                  mdi-triangle-small-down
                </v-icon>
              </span>
            </div>
          </v-list-item-action>
          <v-list-item-content style="max-width: 50%; width: 50%;">
            <v-list-item-title>
              <div class="header-content" @click="toggleSort('testLocalName')">
                <span style="color: white; font-size: 13px" :class="width < 300 ? 'table-header-text' : ''">검사명</span>
                <span class="icon-container">
                  <v-icon size="20"
                    :color="sortColumn === 'testLocalName' && sortDirection === 'asc' ? 'white' : '#E0E0E0'"
                    class="text-right up-icon">
                    mdi-triangle-small-up
                  </v-icon>
                  <v-icon size="20"
                    :color="sortColumn === 'testLocalName' && sortDirection === 'desc' ? 'white' : '#E0E0E0'"
                    class="text-right down-icon">
                    mdi-triangle-small-down
                  </v-icon>
                </span>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-virtual-scroll id="virtualScroll" ref="virtualScroll" :items="sortedTestLibraryList"
          :height="listHeight - 85" :item-height="55">

          <template v-slot:default="{ item, index }">
            <div id=""></div>
            <v-list-item @click="getLibraryTestInfo(item.testCode)" class="px-2" style="height:55px"
              :id="index === 0 ? 'firstIndex' : ''" :ripple="false">
              <v-list-item-action style="width: 20%; max-width: 20%;" class="mr-0 d-flex justify-center">
                <span style="font-size: 13px;" :class="width < 300 ? 'vw-text' : ''">{{ item.testCode }}</span>
              </v-list-item-action>

              <v-list-item-action style="width: 25%; max-width: 25%;" class="mr-0 d-flex justify-center">
                <span style="font-size: 13px;" :class="width < 300 ? 'vw-text' : ''">
                  <span v-if="item.insuranceCode && item.insuranceCode.length >= 10 && item.insuranceCode.length <= 30">
                    {{ splitStringEqually(item.insuranceCode)[0] }}
                    <br />
                    {{ splitStringEqually(item.insuranceCode)[1] }}
                  </span>
                  <span v-else-if="item.insuranceCode && item.insuranceCode.length > 30">
                    {{ splitStringIntoThree(item.insuranceCode)[0] }}
                    <br />
                    {{ splitStringIntoThree(item.insuranceCode)[1] }}
                    <br />
                    {{ splitStringIntoThree(item.insuranceCode)[2] }}
                  </span>
                  <span v-else>
                    {{ item.insuranceCode }}
                  </span>
                </span>
              </v-list-item-action>

              <v-list-item-action class="text-center my-1 d-flex justify-start"
                style="font-size: 13px; max-width:50%; width: 50%;">
                <span class="text-center" :class="width < 300 ? 'vw-text' : ''" v-if="testNameIsKorean === true">
                  {{ item.testLocalName }}
                </span>
                <span class="text-center" :class="width < 300 ? 'vw-text' : ''" v-if="testNameIsKorean === false">
                  {{ item.testName }}
                </span>
              </v-list-item-action>
            </v-list-item>

            <back-to-top
              v-show="dialog === false & ($refs.codeTestPartBottomSheet && !$refs.codeTestPartBottomSheet.bottomSheetOpen)"
              bottom="40px" right="20px" visibleoffset="120">
              <v-btn :ripple="false" icon class="btn-to-top" @click="scrollToTop()">
                <v-icon color="#959595">mdi-arrow-collapse-up</v-icon>
              </v-btn>
            </back-to-top>

            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
        <template>
          <v-dialog v-model="dialog" hide-overlay :fullscreen="!isIos" class="dialog-area" scrollable max-width="600px">
            <v-card :class="isIos ? 'dialog-area' : ''" elevation="0">
              <v-card-title style="font-size: 1.25rem;" class="justify-center">
                <v-btn class="d-flex justify-start no-background-hover" :ripple="false" icon absolute left
                  @click="closeDialog()">
                  <img src="../../assets/btn_pre_n.png" class="btn_pre_img">
                </v-btn><span class="text-center" style="font-weight:600">검사 상세</span>
              </v-card-title>
              <v-divider style="color: black;"></v-divider>
              <v-card-text class="px-0">
                <v-container fluid class="px-0">
                  <span id="topCard"></span>
                  <v-select item-color="success" color="success" outlined hide-details="" single-line dense
                    label="검체 설정" auto-select-first v-model="selectedSpecime" :items="specimens"
                    class=" px-1 mt-1 text-field input_arrow rounded-lg" @change="changeSpecimen(selectedSpecime)"
                    :class="width < 300 ? 'vw-text' : ''">
                    <template v-slot:append>
                      <img src="../../assets/btn_input_arrow.png" class="input_arrow_img">
                    </template>
                  </v-select>
                  <template>
                    <v-simple-table dense id="table" height="100%" hide-default-header hide-default-footer>
                      <template v-slot:default>

                        <tbody style="font-size: 13px;">
                          <tr class="tr-text">
                            <td class="pl-2">
                              <span class="text--secondary td-text" :class="width < 300 ? 'vw-text' : ''">
                                {{ LibraryTestInfo.testCode }}
                              </span>
                            </td>
                            <td>
                              <!-- <span class="td-text" :class="width < 300 ? 'vw-text' : ''">
                                {{ LibraryTestInfo.testName }}
                              </span> -->

                              <span class="td-text" :class="width < 300 ? 'vw-text' : ''"
                                v-if="testNameIsKorean === true">
                                {{ LibraryTestInfo.testLocalName }}
                              </span>
                              <span class="td-text" :class="width < 300 ? 'vw-text' : ''"
                                v-if="testNameIsKorean === false">
                                {{ LibraryTestInfo.testName }}
                              </span>
                            </td>
                          </tr>
                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-0" style="font-size: 13px;"
                              :class="width < 300 ? 'vw-text' : ''">보험코드</td>
                            <td class="detail-table td-text " :class="width < 300 ? 'vw-text' : ''"> {{
                              LibraryTestInfo.insuranceCode
                            }}</td>
                          </tr>
                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">분류번호
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{
                              LibraryTestInfo.insuranceClassChar }}</td>
                          </tr>
                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-0">
                              <span :class="width < 300 ? 'vw-text' : ''">보험수가</span><br />
                              <span style="font-size: 6px !important;">질가산 미포함</span>
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">
                              {{ LibraryTestInfo.emrfeesPrice
                                === '문의' ? '문의' :
                                subStringPrice(LibraryTestInfo.emrfeesPrice) }}
                              <span
                                v-show="LibraryTestInfo.emrfeesPrice !== '문의' && LibraryTestInfo.emrfeesPrice !== '-'">원</span>
                            </td>
                          </tr>
                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-1" :class="width < 300 ? 'vw-text' : ''">상대가치점수
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{
                              LibraryTestInfo.insuranceScore }}</td>
                          </tr>
                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">질가산점수
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{
                              LibraryTestInfo.qualityAddScore }}</td>
                          </tr>
                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-0">
                              <span :class="width < 300 ? 'vw-text' : ''">기준수가</span>
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.basisPrice ===
                              '문의' ? '문의' :
                              subStringPrice(LibraryTestInfo.basisPrice) }} <span
                                v-show="LibraryTestInfo.basisPrice !== '문의' && LibraryTestInfo.basisPrice !== '-'">원</span>
                            </td>
                          </tr>

                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">검사방법
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.methodName }}
                            </td>
                          </tr>
                          <tr class="tr-text" :class="width < 300 ? 'vw-text' : ''">
                            <td class="td-text text--secondary pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">검사일</td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.testTerm }}
                            </td>
                          </tr>
                          <tr class="tr-text" :class="width < 300 ? 'vw-text' : ''">
                            <td class="td-text text--secondary pl-2" :class="width < 300 ? 'vw-text' : ''">소요일</td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{
                              LibraryTestInfo.testNeccessaryDay }}일</td>
                          </tr>
                          <tr class="tr-text" :class="width < 300 ? 'vw-text' : ''">
                            <td class="td-text text--secondary pl-2" :class="width < 300 ? 'vw-text' : ''">검체</td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.specimenName }}
                            </td>
                          </tr>
                          <tr class="tr-text " :class="width < 300 ? 'vw-text' : ''">
                            <td class="td-text text--secondary pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">적정채취량
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.volumeOptimum
                            }}</td>
                          </tr>

                          <tr class="tr-text" :class="width < 300 ? 'vw-text' : ''">
                            <td class="td-text text--secondary pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">보관방법
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.keepMethod }}
                            </td>
                          </tr>
                          <tr class="tr-text" :class="width < 300 ? 'vw-text' : ''">
                            <td class="td-text text--secondary pl-2 pr-0" width="60"
                              :class="width < 300 ? 'vw-text' : ''">
                              검체안정성</td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{
                              LibraryTestInfo.specimenStability }}</td>
                          </tr>
                          <tr class="tr-text" style="height: 120px !important;" :class="width < 300 ? 'vw-text' : ''">
                            <td class="td-text text--secondary pl-2" :class="width < 300 ? 'vw-text' : ''">참고치</td>
                            <td class="td-text" style="white-space: pre-line" :class="width < 300 ? 'vw-text' : ''">{{
                              LibraryTestInfo.referenceTextDisplay
                            }}{{ LibraryTestInfo.referenceUnit }}</td>
                          </tr>
                          <tr class="tr-text">
                            <td class="td-text text--secondary pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">검사항목
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.testItem }}
                            </td>
                          </tr>
                          <tr class="tr-text">
                            <td class="td-text text--secondary pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">용기보관
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{
                              LibraryTestInfo.containerKeepMethod }}</td>
                          </tr>
                          <tr class="tr-text" style="height: 120px !important;">
                            <td class="td-text text--secondary pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">참고사항
                            </td>
                            <td class="td-text" style="white-space: pre-line" :class="width < 300 ? 'vw-text' : ''">{{
                              LibraryTestInfo.containerNote
                            }}</td>
                          </tr>
                          <tr class="tr-text" :class="width < 300 ? 'vw-text' : ''">
                            <td class="td-text text--secondary pl-2 pr-0" :class="width < 300 ? 'vw-text' : ''">검사기관
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.labName }}</td>
                          </tr>
                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-0">
                              <span :class="width < 300 ? 'vw-text' : ''">센터가격</span>
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.agencyPrice ===
                              '문의' ? '문의' :
                              subStringPrice(LibraryTestInfo.agencyPrice) }} <span
                                v-show="LibraryTestInfo.agencyPrice !== '문의' && LibraryTestInfo.agencyPrice !== '-'">원</span>
                            </td>
                          </tr>
                          <tr class="tr-text">
                            <td class="text--secondary td-text pl-2 pr-0">
                              <span :class="width < 300 ? 'vw-text' : ''">최저가격</span>
                            </td>
                            <td class="td-text" :class="width < 300 ? 'vw-text' : ''">{{ LibraryTestInfo.lowestPrice ===
                              '문의' ? '문의' :
                              subStringPrice(LibraryTestInfo.lowestPrice) }} <span
                                v-show="LibraryTestInfo.lowestPrice !== '문의' && LibraryTestInfo.lowestPrice !== '-'">원</span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-card elevation="0" class="mt-4 image-container" style="background-color: #f6f6f6;">

                      <p v-show="LibraryTestInfo.purpose !== ''" class="pr-3 pt-6"
                        style="font-size: 1rem; font-weight: 700; color: darkblue;">검사목적</p>
                      <p class="pr-3 text-body-2" style="white-space: pre-line">{{ LibraryTestInfo.purpose
                      }}</p>

                      <p v-show="LibraryTestInfo.clinicalSigni !== ''" class="pr-3 pt-6"
                        style="font-size: 1rem; font-weight: 700; color: darkblue;">임상적 의의</p>
                      <p class="pr-3 text-body-2" style="white-space: pre-line">{{ LibraryTestInfo.clinicalSigni
                      }}</p>

                      <p class="text-body-2 mb-1">[관련질환]</p>
                      <p class="pr-1 text-body-2" style="white-space: pre-line">
                        <v-icon x-large style="color: red;"
                          v-show="LibraryTestInfo.hightSigni !== ''">mdi-menu-up</v-icon>
                        <span v-show="LibraryTestInfo.hightSigni !== ''">{{ LibraryTestInfo.hightSigni }}</span>
                      </p>
                      <p class="pr-1 text-body-2" style="white-space: pre-line">
                        <v-icon x-large style="color: blue;"
                          v-show="LibraryTestInfo.lowSigni !== ''">mdi-menu-down</v-icon>
                        <span v-show="LibraryTestInfo.lowSigni !== ''">{{ LibraryTestInfo.lowSigni }}</span>
                      </p>

                      <p v-show="LibraryTestInfo.relatedTest && LibraryTestInfo.relatedTest.length > 0"
                        class="pr-5 mb-1" style="font-size: 1rem; font-weight: 700; color: darkblue;">관련검사</p>
                      <span style="color: skyblue;" @click="getLibraryTestInfo(item.relatedTestCode)"
                        v-for="item in LibraryTestInfo.relatedTest" :key="item.relatedTestCode"
                        class="text-body-2 pr-0 ">{{
                          item.relatedTestName }}, </span>

                      <p v-show="LibraryTestInfo.notice !== ''" class="pr-5 pt-5 mb-1"
                        style="font-size: 1rem; font-weight: 700; color: darkblue;">유의사항</p>
                      <p class="text-body-2 pr-3" v-if="LibraryTestInfo.notice !== ''" v-html="LibraryTestInfo.notice">
                      </p>

                      <p v-show="LibraryTestInfo.reference !== ''" class="pr-5 mb-1 pt-5"
                        style="font-size: 1rem; font-weight: 700; color: darkblue;">참고사항</p>
                      <p class="text-body-2 pr-3" v-if="LibraryTestInfo.reference !== ''"
                        v-html="LibraryTestInfo.reference">
                      </p>

                      <p v-show="LibraryTestInfo.academicNotify && LibraryTestInfo.academicNotify.length > 0"
                        class="pr-5" style="font-size: 1.2rem; font-weight: 700; color: darkblue;">보험급여 심사정보</p>
                      <p class="font-weight-black mb-0"
                        v-show="LibraryTestInfo.academicNotify && LibraryTestInfo.academicNotify.length > 0"
                        style="font-size: 1rem;">
                        [급여기준]</p>
                      <p v-for="item in LibraryTestInfo.academicNotify" :key="item.NotifyContents"
                        class="text-body-2 px-4" style="white-space: pre-line">
                        {{ item.NotifyContents }}
                      </p>
                    </v-card>
                  </template>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>
      </v-card>

      <codeTestPartBottomSheetVue :partName="partName" :codePart="codePart"
        @onSelectedForPartName="onSelectedForPartName" @onSelected="onSelected" ref="codeTestPartBottomSheet">
      </codeTestPartBottomSheetVue>
    </template>

  </div>
</template>
<style scoped>
@import '@/assets/css/commonCSS.css';

.td-text {
  font-size: 13px;
}

.td-text-2 {
  font-size: 11px !important;
}

.tr-text:hover {
  background-color: transparent !important;
}
</style>
<style>
.image-container img {
  height: auto;
  max-width: 100%;
}
</style>
<script>
import goTo from 'vuetify/lib/services/goto'
import backButton from '../backButton'
import _ from 'lodash'
import * as testAPI from './testAPI'
import codeTestPartBottomSheetVue from './codeTestPartBottomSheet.vue'
import sortingMixin from '../sortingMixin'
import subStringPrice from '../subStringPrice'
import * as CommonFunction from '../commonFunction'
import scrollMixin from '../scrollMixin'
import listToTopMixin from '../../mixin/listToTopMixin'
import search from 'hangul-chosung-search'
import widthMixin from '../widthMixin'
import { nextTick } from 'vue'
export default {

  mixins: [
    backButton(['PDFdialog', 'dialog', 'modal']),
    sortingMixin,
    listToTopMixin,
    scrollMixin,
    widthMixin
  ],

  components: {
    codeTestPartBottomSheetVue
  },

  data() {
    return {

      dialog: false,
      infiniteId: +new Date(), // 검색 기능 사용시 무한 스크롤 초기화
      headers: [
        {
          text: '검사코드',
          align: 'center',
          class: 'text-center',
          value: 'testCode'
        },
        {
          text: '청구코드',
          align: 'center',
          class: 'text-center',
          value: 'insuranceCode'
        },
        {
          text: '검사명',
          align: 'center',
          class: 'text-center',
          value: 'testLocalName'
        }
      ],
      searchWord: '',

      searchTypeList: [
        {
          text: '검사명칭(한글)',
          value: '1'
        },
        {
          text: '검사코드',
          value: '2'
        },
        {
          text: '출력이름',
          value: '3'
        }
      ],

      UserInfo: {},
      TestCode: '',
      TestKORName: '',
      DisplayName: '',
      list: [],
      searchList: [],
      LibraryTestInfo: {},
      codePart: '',
      partList: [],
      partName: '',
      Page: 1,
      specimens: [],
      selectedSpecime: '',
      imageSource: '',
      sortColumn: 'clientCode',
      sortDirection: 'asc',
      isActive: false,
      isLoading: true,
      defaultHeight: '50',
      dialogLoading: true,
      isIos: false,
      prevPath: '',
      testNameIsKorean: false,
      testNameIsEnglish: false
    }
  },

  computed: {

    getUserID: function () {
      return this.$store.getters['userStore/getUserID']
    },

    getPassword: function () {
      return this.$store.getters['userStore/getPassword']
    },

    getUserInfo: function () {
      return this.$store.getters['userStore/getUserInfo']
    },

    getCurrentPath: function () {
      return this.$store.getters.getCurrentPath
    },

    getTestLibrarySearchWord: function () {
      return this.$store.getters['testStore/getTestLibrarySearchWord']
    },

    getTestLibrary: function () {
      return this.$store.getters['testStore/getTestLibrary']
    },

    getTestNameIsKorean: function () {
      return this.$store.getters['testStore/getTestNameIsKorean']
    },

    sortedTestLibraryList() {
      if (this.sortColumn) {
        const sortedArray = this.searchList.slice().sort((a, b) => {
          const aValue = a[this.sortColumn]
          const bValue = b[this.sortColumn]

          if (aValue < bValue) {
            return this.sortDirection === 'asc' ? -1 : 1
          } else if (aValue > bValue) {
            return this.sortDirection === 'asc' ? 1 : -1
          } else {
            return 0
          }
        })

        return sortedArray
      } else {
        return this.searchList
      }
    },
    isMobile() {
      return CommonFunction.isMobile()
    }
  },

  created() {
    this.UserInfo = this.getUserInfo
    this.prevPath = this.getCurrentPath
    this.testNameIsKorean = this.getTestNameIsKorean
    if (this.prevPath === '/testResult' && Object.keys(this.$route.params).length !== 0) {
      let testCode = this.$route.params.testCode
      this.isLoading = true
      this.getLibraryTestInfo(testCode)
    }
    this.getCdoeTestPart()
    this.getLibraryTestList()
    this.$store.commit('mutationCurrentPath', window.location.pathname)
    this.sortColumn = 'testCode'
    if (CommonFunction.isIOS()) {
      this.isIos = true
    }
  },

  mounted() {
    const screenHeight = window.innerHeight
  },

  watch: {

    searchWord() {
      this.searchedList()
    },

    codePart: function () {
      this.searchedList()
    },

    partName: function () {
      if (this.partName[0] === ',') {
        this.partName = this.partName.slice(1)
      }
    },

    dialog: function () {
      if (this.dialog === true) {

      } else {
        goTo(0)
        document.body.style.overscrollBehaviorY = 'auto'
      }
    },

    testNameIsKorean: function () {
      if (this.testNameIsKorean !== this.getTestNameIsKorean) {
        this.$store.commit('testStore/mutationTestNameIsKorean', this.testNameIsKorean)
      }
    }

  },

  methods: {

    splitStringEqually(str) {
      if (str) {
        return CommonFunction.splitStringEqually(str)
      }
    },

    splitStringIntoThree(str) {
      if (str) {
        return CommonFunction.splitStringIntoThree(str)
      }
    },

    toBack(e) {
      if (CommonFunction.isIOS()) {
        if (this.currentCompentName !== '/') {
          this.$router.go(-1)
        }
      }
    },

    dialogToTop() {
      document.getElementById('topCard').scrollIntoView(true)
    },

    setTestNameIsKorean(value) {
      this.$store.commit('testStore/mutationTestNameIsKorean', value)
    },

    getLibraryTestInfo(testCode) {
      this.isLoading = true
      this.dialogLoading = true
      testAPI.getLibraryTestInfo(this.UserInfo.UserID, this.UserInfo.Password, testCode)
        .then((res) => {
          this.LibraryTestInfo = res.data.result
          this.specimens = []

          for (let i = 0; i < this.LibraryTestInfo.libraryTestSpecimen.length; i++) {
            let specimen = this.LibraryTestInfo.libraryTestSpecimen[i].specimenName
            this.specimens.push(specimen)
          }

          this.selectedSpecime = this.LibraryTestInfo.libraryTestSpecimen[0].specimenName

          this.setLibraryTestInfo(this.LibraryTestInfo.libraryTestSpecimen[0])
          this.isLoading = false
          // setTimeout(() => {
          //   this.dialogToTop()
          // }, 50);
          this.$nextTick(() => {
            this.dialogToTop()
          })
          this.dialogLoading = false
          this.dialog = true
          this.isLoading = false
        })
    },

    changeSpecimen(selectedSpecime) {
      for (let i = 0; i < this.specimens.length; i++) {
        if (this.LibraryTestInfo.libraryTestSpecimen[i].specimenName === selectedSpecime) {
          this.setLibraryTestInfo(this.LibraryTestInfo.libraryTestSpecimen[i])
        }
      }
    },

    subStringPrice(price) {
      if (isNaN(parseInt(price, 10))) {
        return '-'
      }
      return subStringPrice(price)
    },

    setLibraryTestInfo(LibraryTestInfo) {
      this.LibraryTestInfo.testTerm = LibraryTestInfo.testTerm
      this.LibraryTestInfo.specimenName = LibraryTestInfo.specimenName
      this.LibraryTestInfo.testNeccessaryDay = LibraryTestInfo.testNeccessaryDay
      this.LibraryTestInfo.keepMethod = LibraryTestInfo.keepMethod
      this.LibraryTestInfo.specimenStability = LibraryTestInfo.specimenStability
      this.LibraryTestInfo.referenceTextDisplay = LibraryTestInfo.referenceTextDisplay
      this.LibraryTestInfo.referenceUnit = LibraryTestInfo.referenceUnit
      this.LibraryTestInfo.containerNote = LibraryTestInfo.containerNote
      this.LibraryTestInfo.testItem = LibraryTestInfo.testItem
      this.LibraryTestInfo.containerKeepMethod = LibraryTestInfo.containerKeepMethod
      this.LibraryTestInfo.labName = LibraryTestInfo.labName
      this.LibraryTestInfo.volumeOptimum = LibraryTestInfo.volumeOptimum
    },

    // async getLibraryTestList() {
    //   const res = await testAPI.getLibraryTestList(this.UserInfo.UserID, this.UserInfo.Password);

    //   this.$store.commit('testStore/mutationTestLibrarySearchWord', this.searchWord);
    //   this.processData(res.data.result);
    // },

    // processData(data) {
    //   // this.LibraryTestList = await [...data];
    //   this.searchList = [...data];
    //   this.isLoading = false
    // },

    // getLibraryTestList() {
    //   testAPI.getLibraryTestList(this.UserInfo.UserID, this.UserInfo.Password)
    //   .then((res) => {
    //     this.list = res.data.result
    //     this.searchList = res.data.result
    //     this.isLoading = false
    //   })
    // },

    async getLibraryTestList() {
      const response = await testAPI.getLibraryTestList(this.UserInfo.UserID, this.UserInfo.Password)
      this.isLoading = false
      const { result: data } = response.data

      this.$store.commit('testStore/mutationTestLibrarySearchWord', this.searchWord)

      // 데이터를 청크 단위로 처리
      const chunkSize = 300 // 청크 크기 설정
      let index = 0

      const processChunk = async () => {
        const chunk = data.slice(index, index + chunkSize)

        // 데이터 처리 로직을 수행
        this.processData(chunk)

        index += chunkSize

        if (index < data.length) {
          // 다음 청크로 넘어가기 전에 일정 시간 대기
          await new Promise(resolve => setTimeout(resolve, 10))

          // 다음 청크 처리
          processChunk()
        }
      }

      processChunk()
    },

    closeDialog() {
      this.dialog = false
      if (this.prevPath === '/testResult') {
        // this.$router.replace("/testResult")
        this.$router.go(-1)
      }
    },

    processData(data) {
      this.list = this.list.concat(data)
      this.searchList = this.searchList.concat(data)
    },

    onSelected(selectedCodePart) {
      this.codePart = selectedCodePart
    },

    isAllKoreanConsonants(str) {
      // 모든 문자가 한글 자음 또는 다른 문자인지 확인하는 정규표현식
      const allKoreanConsonantsRegex = /^[ㄱ-ㅎa-zA-Z]*$/

      // 정규표현식과 매치하여 결과 반환
      return allKoreanConsonantsRegex.test(str)
    },

    searchedList() {
      const query = this.searchWord.toLowerCase() // 검색어를 소문자로 변환
      this.searchList = this.list.filter(element =>
        (element.testCode && element.testCode.toLowerCase().includes(query)) ||
        (element.displayName && element.displayName.toLowerCase().includes(query)) ||
        (element.testName && element.testName.toLowerCase().includes(query)) ||
        (element.testLocalName && element.testLocalName.toLowerCase().includes(query)) ||
        (element.testEngName && element.testEngName.toLowerCase().includes(query)) ||
        (element.insuranceCode && element.insuranceCode.toLowerCase().includes(query))
      )

      if (this.codePart.length > 0) {
        this.searchList = this.searchList.filter(element => this.codePart.includes(element.partCode))
      }

      this.isLoading = false
    },

    onSelectedForPartName(onSelectedForPartName) {
      this.partName = onSelectedForPartName
    },

    open() {
      this.$refs.codeTestPartBottomSheet.bottomSheetOpen = true
    },

    toMain() {
      this.$router.push('/')
    },

    getCdoeTestPart() { // 검사 파트 조회
      testAPI.getCdoeTestPart(this.getUserID, this.getPassword)
        .then((res) => {
          this.partList = res.data.result
        })
    },

    close() {
      this.dialog = false
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path === '/testLibrary' || to.path === '/testLibraryInfo') {
      next()
    } else if (this.prevPath === '/testResult') {
      this.dialog = false
      next()
    } else {
      this.$store.commit('testStore/mutationTestLibrary', {})
      next()
    }
  }
}
</script>
